import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Agenda } from './components/Agenda';
import { WhyAttend } from './components/WhyAttend';
import { VenueHighlight } from './components/VenueHighlight';
import { Registration } from './components/Registration';
import { Sponsors } from './components/Sponsors';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFF8DC]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Sponsors data-id="element-4" />
        <About data-id="element-5" />
        <WhyAttend data-id="element-6" />
        <Agenda data-id="element-7" />
        <VenueHighlight data-id="element-8" />
        <Registration data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}